import { computed } from 'vue'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import isBetween from 'dayjs/plugin/isBetween'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import { DATE_TIME_FORMAT } from '~/constants'

dayjs.extend(utc)
dayjs.extend(isBetween)
dayjs.extend(customParseFormat)
dayjs.extend(isSameOrBefore)

export function useDayTimeEvent() {
  const runtimeConfig = useRuntimeConfig()
  const initDaytimeEvent = runtimeConfig.public.EVENT_HALLOWEEN_DATE ?? ''

  const dayTimeEvent = computed(() => {
    const [start, end] = initDaytimeEvent.split(',')
    const startDate = dayjs(start, DATE_TIME_FORMAT.DATE_FORMAT)
    const endDate = dayjs(end, DATE_TIME_FORMAT.DATE_FORMAT)
    const startDateFull = dayjs(start, DATE_TIME_FORMAT.DATE_FORMAT).format(DATE_TIME_FORMAT.SHORT_DATE_FORMAT)
    const endDateFull = dayjs(end, DATE_TIME_FORMAT.DATE_FORMAT).format(DATE_TIME_FORMAT.SHORT_DATE_FORMAT)
    const startDateFormatDateParam = dayjs(start, DATE_TIME_FORMAT.DATE_FORMAT).format(
      DATE_TIME_FORMAT.DATE_FORMAT_PARAMS
    )
    const endDateFormatDateParam = dayjs(end, DATE_TIME_FORMAT.DATE_FORMAT).format(DATE_TIME_FORMAT.DATE_FORMAT_PARAMS)
    const now = dayjs()

    const isEndEvent = now.isAfter(endDate, 'day')
    const isStartedEvent = startDate.isSameOrBefore(now, 'day')
    const isGoingEvent = now.isBetween(startDateFormatDateParam, endDateFormatDateParam, 'day', '[]')

    return {
      startDate,
      endDate,
      rangeDate: `${startDate.format(DATE_TIME_FORMAT.DAY_MONTH)} - ${endDate.format(DATE_TIME_FORMAT.DAY_MONTH)}`,
      rangeDateInfo: `${startDate.format(DATE_TIME_FORMAT.DAY_MONTH)} - ${endDate.format(
        DATE_TIME_FORMAT.DATE_FORMAT
      )}`,
      isEndEvent,
      isStartedEvent,
      startDateFull,
      endDateFull,
      isGoingEvent
    }
  })

  return {
    dayTimeEvent
  }
}
